import React, { Component } from 'react';
import { Modal, Button, FormGroup, FormControl, ControlLabel, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { notify } from 'react-notify-toast';

type IProps = {
  item: Object,
  onClose: () => void,
  onSave: (item: Object) => void,
  onRemove: () => void,
}

type IState = {
  key: string,
  name: string,
  enabled: boolean,
  description: string,
}

class ModalLesson extends Component {

  constructor(props: IProps) {
    super(props);

    this.state = {
      key: '',
      name: '',
      enabled: false,
      description: '',
    };
  }

  componentWillReceiveProps(nextProps: IProps) {
    const { item } = nextProps;

    if (item) {
      const key = item.key || '';
      const name = item.name || '';
      const enabled = item.enabled || false;
      const description = item.description || '';

      this.setState({
        key,
        name,
        enabled,
        description,
      });
    }
  }
  
  state: IState;

  handleOnSave(e) {
    const { onSave } = this.props;
    const { key, name, enabled, description } = this.state;

    if (name.length === 0) {
      notify.show('Please fill correctly!', 'warning', 3000);
      return;
    }

    onSave({
      key,
      name,
      enabled,
      description,
    });
  }

  handleOnRemove(e) {
    if (window.confirm('Are you sure?')) {
      const { onRemove } = this.props;
      onRemove();
    }
  }

  handleOnClose(e) {
    const { onClose } = this.props;

    onClose();
  }

  handleChangeName(e) {
    this.setState({
      name: e.target.value
    });
  }

  handleChangeEnabled(value) {
    this.setState({
      enabled: value,
    });
  }

  handleChangeDescription(e) {
    this.setState({
      description: e.target.value
    });
  }

  props: IProps;

  render() {
    const { name, enabled, description } = this.state;

    if (!this.props.item) {
      return (
        <Modal show={false} />
      );
    }
   
    let title = 'Add new lesson';
    if (this.props.item.key) {
      title = `Edit lesson: ${this.props.item.name}`;
    }

    return (
      <Modal show={this.props.item ? true : false} onHide={this.handleOnClose.bind(this)} backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="name">
            <ControlLabel>Name</ControlLabel>
            <FormControl id="name" type="text" onChange={this.handleChangeName.bind(this)} value={name} />
          </FormGroup>
          <FormGroup>
            <ButtonToolbar>
              <ToggleButtonGroup type="radio" name="enabled" onChange={this.handleChangeEnabled.bind(this)} value={enabled} defaultValue={false}>
                <ToggleButton value={true}>Enabled</ToggleButton>
                <ToggleButton value={false}>Disabled</ToggleButton>
              </ToggleButtonGroup>
            </ButtonToolbar>
          </FormGroup>
          <FormGroup controlId="description">
            <ControlLabel>Description</ControlLabel>
            <FormControl id="description" componentClass="textarea" onChange={this.handleChangeDescription.bind(this)} value={description} />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          {
            this.props.item.key && <Button onClick={this.handleOnRemove.bind(this)} bsStyle="danger" style={{ float: 'left' }}>Remove this lesson</Button>
          }
          <Button onClick={this.handleOnClose.bind(this)}>Close</Button>
          <Button bsStyle="primary" onClick={this.handleOnSave.bind(this)}>Save</Button>
        </Modal.Footer> 
      </Modal>
    );
  }
}

export default ModalLesson;



// WEBPACK FOOTER //
// ./src/pages/Lessons/ModalLesson.js